import { put, call, takeLatest, takeEvery, select } from 'redux-saga/effects'
import apiClient from 'admin/api/apiClient'
import { notifyError, notifySuccess } from 'shared/sharedMethod'
import { defaultValue } from 'admin/pages/home/common/store_product_prices/storeProductPriceDefaultValue'
import * as loadingDuck from './loading.duck'
//utils
import { resortPosition } from 'shared/utils/arrayMethod'

// Actions
export const actionTypes = {
  CREATE_STORE_PRODUCT_PRICE: 'storeProductPrice/CREATE_STORE_PRODUCT_PRICE',
  FETCH_STORE_PRODUCT_PRICES: 'storeProductPrice/FETCH_STORE_PRODUCT_PRICES',
  FETCH_STORE_PRODUCT_PRICE: 'storeProductPrice/FETCH_STORE_PRODUCT_PRICE',
  UPDATE_STORE_PRODUCT_PRICE: 'storeProductPrice/UPDATE_STORE_PRODUCT_PRICE',
  DELETE_STORE_PRODUCT_PRICE: 'storeProductPrice/DELETE_STORE_PRODUCT_PRICE',
  DELETE_STORE_PRODUCT_PRICE_BY_POSITION: 'storeProductPrice/DELETE_STORE_PRODUCT_PRICE_BY_POSITION',

  STORE_PRODUCT_PRICE_CREATED: 'storeProductPrice/STORE_PRODUCT_PRICE_CREATED',
  STORE_PRODUCT_PRICES_LOADED: 'storeProductPrice/STORE_PRODUCT_PRICES_LOADED',
  STORE_PRODUCT_PRICE_LOADED: 'storeProductPrice/STORE_PRODUCT_PRICE_LOADED',
  STORE_PRODUCT_PRICE_UPDATED: 'storeProductPrice/STORE_PRODUCT_PRICE_UPDATED',
  STORE_PRODUCT_PRICE_INLINE_UPDATED: 'storeProductPrice/STORE_PRODUCT_PRICE_INLINE_UPDATED',
  STORE_PRODUCT_PRICE_DELETED: 'storeProductPrice/STORE_PRODUCT_PRICE_DELETED',

  INSERT_NEW_ROW: 'storeProductPrice/INSERT_NEW_ROW',

  UPDATE_GRID_INDEX: 'storeProductPrice/UPDATE_GRID_INDEX',
}

const initialState = {
  storeProductPrice: null,
  storeProductPrices: null,
  agGridIndex: 0,
}

// Reducer
export function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.CREATE_STORE_PRODUCT_PRICE:
      return { ...state, storeProductPrice: action.payload }
    case actionTypes.FETCH_STORE_PRODUCT_PRICES:
      return { ...state, storeProductPrices: null }
    case actionTypes.FETCH_STORE_PRODUCT_PRICE:
      return { ...state, storeProductPrice: null }
    case actionTypes.UPDATE_STORE_PRODUCT_PRICE:
      return { ...state, storeProductPrice: action.payload }
    case actionTypes.DELETE_STORE_PRODUCT_PRICE:
      return state

    case actionTypes.STORE_PRODUCT_PRICE_CREATED:
      return !state.storeProductPrices ? { ...state, storeProductPrices: [action.payload] } : { ...state, storeProductPrices: [...state.storeProductPrices, action.payload] }
    case actionTypes.STORE_PRODUCT_PRICES_LOADED:
      return { ...state, storeProductPrices: resortPosition(action.payload) }
    case actionTypes.STORE_PRODUCT_PRICE_LOADED:
      return { ...state, storeProductPrice: action.payload }
    case actionTypes.STORE_PRODUCT_PRICE_UPDATED:
      return {
        ...state,
        storeProductPrice: action.payload,
        storeProductPrices: state.storeProductPrices.map(item => item.id === +action.payload.id ? action.payload : item)
      }
    case actionTypes.STORE_PRODUCT_PRICE_INLINE_UPDATED:
      const { position, updatedData } = action.payload
      return {
        ...state,
        storeProductPrices: state.storeProductPrices.map(item =>
          item.position === position ? { ...item, ...updatedData } : item
        )
      }
    case actionTypes.STORE_PRODUCT_PRICE_DELETED:
      const { position: deleteIdPosition, id: deleteId } = action.payload
      return {
        ...state,
        storeProductPrices: resortPosition(state.storeProductPrices.filter(item => item.id !== deleteId)),
        agGridIndex: deleteIdPosition
      }

    case actionTypes.DELETE_STORE_PRODUCT_PRICE_BY_POSITION:
      const { position: deletePosition } = action.payload
      return {
        ...state,
        storeProductPrices: resortPosition(state.storeProductPrices.filter(item => item.position !== deletePosition)),
        agGridIndex: deletePosition
      }

    case actionTypes.INSERT_NEW_ROW:
      const { insertData } = action.payload
      return {
        ...state,
        storeProductPrices: state?.storeProductPrices ? resortPosition([...state.storeProductPrices, { ...defaultValue, ...insertData }]) : [{ ...defaultValue, ...insertData }],
        agGridIndex: state?.storeProductPrices?.length ? state?.storeProductPrices?.length : 0
      }

    case actionTypes.UPDATE_GRID_INDEX:
      const { index: gridIndex } = action.payload
      return { ...state, agGridIndex: gridIndex }

    default:
      return state
  }
}

// Action Creators
export const actions = {
  createStoreProductPrice: (storeProductPrice, { callback, isLast }) => ({ type: actionTypes.CREATE_STORE_PRODUCT_PRICE, payload: { storeProductPrice, callback, isLast } }),
  fetchStoreProductPrices: () => ({ type: actionTypes.FETCH_STORE_PRODUCT_PRICES }),
  fetchStoreProductPrice: (id) => ({ type: actionTypes.FETCH_STORE_PRODUCT_PRICE, payload: id }),
  updateStoreProductPrice: (storeProductPrice, { callback, isLast }) => ({ type: actionTypes.UPDATE_STORE_PRODUCT_PRICE, payload: { storeProductPrice, callback, isLast } }),
  deleteStoreProductPrice: (id, position) => ({ type: actionTypes.DELETE_STORE_PRODUCT_PRICE, payload: { id, position } }),
  deleteStoreProductPriceByPosition: (position) => ({ type: actionTypes.DELETE_STORE_PRODUCT_PRICE_BY_POSITION, payload: { position } }),
  storeProductPriceCreated: (storeProductPrice) => ({ type: actionTypes.STORE_PRODUCT_PRICE_CREATED, payload: storeProductPrice }),
  storeProductPricesLoaded: (storeProductPrices) => ({ type: actionTypes.STORE_PRODUCT_PRICES_LOADED, payload: storeProductPrices }),
  storeProductPriceLoaded: (storeProductPrice) => ({ type: actionTypes.STORE_PRODUCT_PRICE_LOADED, payload: storeProductPrice }),
  storeProductPriceUpdated: (storeProductPrice) => ({ type: actionTypes.STORE_PRODUCT_PRICE_UPDATED, payload: storeProductPrice }),
  storeProductPriceInlineUpdated: (position, updatedData) => ({ type: actionTypes.STORE_PRODUCT_PRICE_INLINE_UPDATED, payload: { position, updatedData } }),
  storeProductPriceDeleted: (id, position) => ({ type: actionTypes.STORE_PRODUCT_PRICE_DELETED, payload: { id, position } }),

  insertNewRow: (insertData) => ({ type: actionTypes.INSERT_NEW_ROW, payload: { insertData } }),

  updateGridIndex: (index) => ({ type: actionTypes.UPDATE_GRID_INDEX, payload: { index } }),
}

// Saga
export function* saga() {
  yield takeEvery(actionTypes.CREATE_STORE_PRODUCT_PRICE, function* createStoreProductPriceSaga(action) {
    const { storeProductPrice, callback, isLast } = action.payload
    try {
      const result = yield call(apiClient.post, 'store-product-prices', storeProductPrice)
      if (isLast) {
        yield put(actions.fetchStoreProductPrices())
        notifySuccess('儲存成功')
      }
    } catch (e) {
      notifyError(e.response ? e.response.statusText : e.message)
    } finally {
      if (callback && isLast) {
        callback()
      }
    }
  })

  yield takeLatest(actionTypes.FETCH_STORE_PRODUCT_PRICES, function* fetchStoreProductPricesSaga() {
    const { user } = yield select(state => state.auth)
    const storeCode = user.stores?.find(item => item.id === user.store_id)?.code
    try {
      yield put(loadingDuck.actions.setLoading(true))
      const result = yield call(apiClient.get, `store-product-prices?store_code=${storeCode}`)
      yield put(actions.storeProductPricesLoaded(result.data.data))
    } catch (e) {
      notifyError(e.response ? e.response.statusText : e.message)
    } finally {
      yield put(loadingDuck.actions.setLoading(false))
    }
  })

  yield takeLatest(actionTypes.FETCH_STORE_PRODUCT_PRICE, function* fetchStoreProductPriceSaga(action) {
    try {
      const id = action.payload
      const result = yield call(apiClient.get, `store-product-prices/${id}`)
      yield put(actions.storeProductPriceLoaded(result.data.data))
    } catch (e) {
      notifyError(e.response ? e.response.statusText : e.message)
    }
  })

  yield takeEvery(actionTypes.UPDATE_STORE_PRODUCT_PRICE, function* updateStoreProductPriceSaga(action) {
    const { storeProductPrice, callback, isLast } = action.payload
    try {
      // 詳細記錄請求資訊
      console.log('更新商品價格請求資料:', storeProductPrice)

      const result = yield call(apiClient.put, `store-product-prices/${storeProductPrice.id}`, storeProductPrice)

      // 記錄 API 回應
      console.log('更新商品價格API回應:', result)

      if (isLast) {
        yield put(actions.fetchStoreProductPrices())
        notifySuccess('儲存成功')
      }
    } catch (e) {
      console.error('更新商品價格錯誤:', e)
      console.error('錯誤詳情:', {
        message: e.message,
        response: e.response,
        status: e.response?.status,
        data: e.response?.data
      })
      notifyError(e.response ? e.response.statusText : e.message)
    } finally {
      if (callback && isLast) {
        callback()
      }
    }
  })

  yield takeLatest(actionTypes.DELETE_STORE_PRODUCT_PRICE, function* deleteStoreProductPriceSaga(action) {
    try {
      const { id, position } = action.payload
      yield call(apiClient.delete, `store-product-prices/${id}`)
      yield put(actions.storeProductPriceDeleted(id, position))
      notifySuccess('刪除成功')
    } catch (e) {
      notifyError(e.response ? e.response.statusText : e.message)
    }
  })
}
